module.exports = __webpack_public_path__ + "img/icon-mac.c0cc9a05.svg";